import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Pagination, FileTemplate } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class FileTemplateService extends BaseApiService<FileTemplate> {
  get cacheKey(): StorageKey {
    return StorageKey.fileTemplateServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/fileTemplates`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }
  list(params: {[params: string]: string}): Promise<Pagination<FileTemplate>> {
    return super.list(params);
  }

  protected unparse(obj) {
    return FileTemplate.unparse(obj);
  }

  protected parse(obj) {
    return FileTemplate.parse(obj);
  }

}
